<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Are you sure you want to add another {{ 'organisation' | ize }}?
  </h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

<div class="modal-body">
  <p>
    Creating an additional {{ 'organisation' | ize }} creates a new subscription
    which will be billed separately.
  </p>

  <p>In most cases you may want to create a new register instead.</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline" (click)="modal.dismiss()">
    Cancel
  </button>
  <button
    class="btn btn-outline"
    type="button"
    (click)="onCreateRegister()"
    authorizeEnable
    [authorizeOrganisation]="OrganisationPermissionType.CreateRegister"
  >
    <i-lucide name="plus"></i-lucide>
    Create register
  </button>
  <button
    class="btn btn-outline"
    type="button"
    (click)="onCreateOrganisation()"
  >
    <i-lucide name="plus"></i-lucide>
    Create {{ 'organisation' | ize }}
  </button>
</div>
